<template>
  <div class="phone-body" :class="$route.name !== 'home'? 'has-bgcolor': ''">
    <div class="phone-body-logo">
      <img src="../assets/nav-phone/feilianwang_logo.png" alt="">
    </div>
    <div class="menu" @click="openMenu">
      <img src="../assets/nav-phone/nav_home_m.png" alt="">
    </div>
  </div>
</template>

<script>
  export default {
    name: "HeaderPhone",
    methods: {
      openMenu() {
        this.$parent.open();
      }
    }
  }
</script>

<style scoped>
  .phone-body {
    width: 100%;
    position: fixed;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 0 40px 0 20px;
    z-index: 2;
    height:90px;
  }

  .has-bgcolor{
    background:rgba(38,45,61,0.6);
  }

  .menu {
    cursor: pointer;
    width: 50px;
    height: 50px;
  }

  .menu img {
    width: 50px;
    height: 50px;
  }

  .phone-body-logo {
    width: 190px;
    height: 78px;
  }

  .phone-body-logo img {
    width: 190px;
    height: 78px;
  }
</style>



// WEBPACK FOOTER //
// src/components/HeaderPhone.vue